import { Component, HostBinding, Input } from "@angular/core";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

@Component({
    selector: "sps-description-list-term, sps-dt",
    templateUrl: "./sps-description-list-term.component.html"
})
export class SpsDescriptionListTermComponent {
    static readonly displayName = "sps-description-list-term / sps-dt";
    static readonly props = {
        required: "boolean",
        error: "boolean",
    };

    @HostBinding("class.sps-description-list__term") readonly _spsDescriptionListTermClass = true;

    @HostBinding("class.sps-description-list__term--required")
    @Input()
    @AttributePresenceInput()
    required;

    @HostBinding("class.sps-description-list__term--error")
    @Input()
    @AttributePresenceInput()
    error;

    @HostBinding("style.msGridRow") rowIndex = 0;
}
